import { ModalConfig } from './modal.model';

const CANCEL_FILE_UPLOAD_BODY =
  'You have started uploading a file but have not yet saved it. Are you sure you want to cancel? Any unsaved changes will be lost.';

/** Shared Cancel File Upload confirmation (lookup educator profile upload flows). */
export function getCancelFileUploadModalConfig(): ModalConfig {
  return {
    heading: 'Cancel File Upload',
    modalContent: CANCEL_FILE_UPLOAD_BODY,
    hasDropdown: false,
    hasTemplate: true,
    align: false,
    headingAlign: 'left',
    panelClass: 'cancelUploadModal',
    buttons: [
      { text: 'Yes, Cancel', code: 'Y' },
      { text: 'No, Continue', code: 'N', btnOutline: true }
    ]
  };
}

export function isCancelFileUploadConfirmed(result: unknown): boolean {
  if (result == null || typeof result !== 'object') {
    return false;
  }
  const r = result as { code?: string; confirmed?: boolean };
  return r.code === 'Y' || r.confirmed === true;
}
